export default {
  data() {
    return {
      maxWidth: 2560,
    }
  },
  computed: {
    types() {
      return this.$store.state.ui.types
    },
  },
  methods: {
    // @todo : enhance this tehcnique to remove BE errors from touched fields
    removeFieldErrors(field) {
      if (this.formErrors[field]) {
        this.$store.commit('profile/removeFieldErrors', field)
      }
    },
    getChartBackgroundColor(color) {
      return [
        'rgba(93,203,233,0.08)',
        'rgba(134,224,75,0.08)',
        'rgba(255,152,126,0.08)',
        'rgba(173,139,212,0.08)',
        'rgba(59,81,213,0.08)',
      ][['blue', 'green', 'orange', 'pink', 'purple',].indexOf(color)]
    },

    getChartColor(color) {
      return [
        'rgba(93,203,233,1)',
        'rgba(134,224,75,1)',
        'rgba(255,152,126,1)',
        'rgba(173,139,212,1)',
        'rgba(59,81,213,1)',
      ][['blue', 'green', 'orange', 'pink', 'purple',].indexOf(color)]
    },

    getDoughnutBackgroundColors(color) {
      return [
        [
          'rgba(93,203,233,1)',
          'rgba(93,203,233,0.16)',
          'rgba(93,203,233,0.84)',
          'rgba(93,203,233,0.32)',
          'rgba(93,203,233,0.68)',
          'rgba(93,203,233,0.48)',
        ],
        [
          'rgba(134,224,75,1)',
          'rgba(134,224,75,0.16)',
          'rgba(134,224,75,0.84)',
          'rgba(134,224,75,0.32)',
          'rgba(134,224,75,0.68)',
          'rgba(134,224,75,0.48)',
        ],
        [
          'rgba(255,152,126,1)',
          'rgba(255,152,126,0.16)',
          'rgba(255,152,126,0.84)',
          'rgba(255,152,126,0.32)',
          'rgba(255,152,126,0.68)',
          'rgba(255,152,126,0.48)',
        ],
        [
          'rgba(173,139,212,1)',
          'rgba(173,139,212,0.16)',
          'rgba(173,139,212,0.84)',
          'rgba(173,139,212,0.32)',
          'rgba(173,139,212,0.68)',
          'rgba(173,139,212,0.48)',
        ],
        [
          'rgba(59,81,213,1)',
          'rgba(59,81,213,0.16)',
          'rgba(59,81,213,0.84)',
          'rgba(59,81,213,0.32)',
          'rgba(59,81,213,0.68)',
          'rgba(59,81,213,0.48)',
        ],
        [
          'rgba(255,82,79,1)',
          'rgba(255,82,79,0.16)',
          'rgba(255,82,79,0.84)',
          'rgba(255,82,79,0.32)',
          'rgba(255,82,79,0.68)',
          'rgba(255,82,79,0.48)',
        ],
      ][['blue', 'green', 'orange', 'pink', 'purple', 'red',].indexOf(color)]
    },
  },
}
